<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  background: var(--color-background);
  color: var(--color-foreground);
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue